import { useTranslation } from 'react-i18next';
import { User } from '@/design-system/icons';
import { NotificationContainer } from './NotificationContainer';
import type { NotificationItem, JoinRequestPayload } from '../types';
import { getNotificationState } from '../types';
import { useFormatRelativeTime } from '@/utils/timeUtils';

export interface JoinRequestRejectedNotificationProps {
  notification: NotificationItem;
  onClick?: () => void;
}

export function JoinRequestRejectedNotification({ notification, onClick }: JoinRequestRejectedNotificationProps) {
  const { t } = useTranslation();
  const payload = notification.payload as unknown as JoinRequestPayload;
  const state = getNotificationState(notification);

  const timestamp = useFormatRelativeTime(notification.created_at);

  const displayName = payload.username || payload.email || t('notifications.unknownUser');

  return (
    <NotificationContainer
      icon={
        <div className="size-8 flex items-center justify-center rounded-full bg-error/10">
          <User className="size-4 text-error" />
        </div>
      }
      timestamp={timestamp}
      state={state}
      onClick={onClick}
    >
      <p className="text-sm text-onsurface">
        <span className="font-medium">{displayName}</span>{' '}
        {t('notifications.joinRequestRejected.message')}
      </p>
      {payload.username && payload.email && (
        <p className="text-xs text-muted truncate">{payload.email}</p>
      )}
    </NotificationContainer>
  );
}
